import { render } from "./AdminGate.vue?vue&type=template&id=24635788"
import script from "./AdminGate.vue?vue&type=script&lang=js"
export * from "./AdminGate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__